var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3125 26.0209C40.3125 23.2034 42.5992 20.9167 45.4167 20.9167V18.875C45.4167 10.7084 43.375 8.66669 35.2084 8.66669H14.7917C6.62504 8.66669 4.58337 10.7084 4.58337 18.875V19.8959C7.40087 19.8959 9.68754 22.1825 9.68754 25C9.68754 27.8175 7.40087 30.1042 4.58337 30.1042V31.125C4.58337 39.2917 6.62504 41.3334 14.7917 41.3334H35.2084C43.375 41.3334 45.4167 39.2917 45.4167 31.125C42.5992 31.125 40.3125 28.8384 40.3125 26.0209Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 30.6146L31.125 18.3646",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1137 30.6146H31.1321",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8637 19.3855H18.8821",
    stroke: "#45B14A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDiscount);
export default __webpack_public_path__ + "static/media/ticket-discount.fd927305e05a5d0140a4042451d7e0be.svg";
export { ForwardRef as ReactComponent };